import { Component, ViewChild, ElementRef } from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {RequestServiceProvider} from "../../providers/request-service/request-service";
import {MapsProvider} from "../../providers/maps/maps";
import {LoadingProvider} from "../../providers/loading/loading";
import {TransactionAlertProvider} from "../../providers/transaction-alert/transaction-alert";

/**
 * Generated class for the CashPickupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cash-pickup',
  templateUrl: 'cash-pickup.html',
})
export class CashPickupPage {
  @ViewChild('map') mapRef: ElementRef;
  public hubs: Array<Object> = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, private request: RequestServiceProvider, private maps: MapsProvider, private loader: LoadingProvider, private alertCtrl: AlertController) {

  }

  cashPickUpDetails(hub) {
    this.navCtrl.push('CashPickupDetailsPage', hub)
  }

  ionViewDidLoad() {
    this.loader.presentLoading('Loading...');
   this.request.getCashPickUpLocations().subscribe(
     data => {
       this.hubs = data;
       this.maps.getCurrentLocation(this.mapRef.nativeElement, data);
       this.loader.loader.dismiss().catch(()=>{});
     },
     error => {
       this.loader.loader.dismiss().catch(()=>{});
       this.presentAlert(error.error.message);
     }
   );
  }

  presentAlert(message) {
    let alert = this.alertCtrl.create({
      subTitle: message,
      buttons: [{
        text: 'Dismiss',
        handler: () => {
          this.navCtrl.pop();
        }
      }]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/cash-pickup/cash-pickup.ts